import { Modal } from "antd";
import { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { TEditingEntity } from "components/feature-entity-linking-page/models";

export function UnsaveConfirmModal({
  onSave,
  editingEntity
}: {
  onSave: () => Promise<void>;
  editingEntity: TEditingEntity | null;
}) {
  const history = useHistory();

  const [isEditingMode, setEditingMode] = useState<boolean>(!!editingEntity);

  useEffect(() => {
    const newValue = !!editingEntity;
    setEditingMode((prev) => {
      if (prev !== newValue) {
        return newValue; // only update if it actually changed
      }
      return prev; // avoid redundant state update
    });
  }, [editingEntity]);

  useEffect(() => {
    if (!isEditingMode) {
      return () => {}; // noop cleanup
    }

    const myConfirm = () => {
      return new Promise<"save" | "discard" | "cancel">((resolve) => {
        const modal = Modal.confirm({
          title: "Unsaved Changes",
          content:
            "You are attempting to leave a page which has unsaved changes. Do you want to save the changes before exiting?",
          style: { top: 10, width: 240 },
          okText: "Save and Exit",
          cancelText: "Discard",
          closable: true,
          className: "skip-listing-window custom-rounded-modal",

          async onOk() {
            await onSave();
            resolve("save");
          },
          onCancel() {
            // This handles the close (X) action or cancel button
            resolve("discard");
          },
          afterClose() {
            // Ensures modal is destroyed properly
            modal.destroy();
          }
        });
      });
    };

    const unblock = history.block(({ pathname }) => {
      myConfirm().then((action) => {
        if (action === "save" || action === "discard") {
          unblock();
          history.push(pathname);
        }
      });
      return false;
    });

    return () => {
      unblock();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isEditingMode]);

  return null;
}
